import script from "./Wonderlic.vue?vue&type=script&setup=true&lang=js"
export * from "./Wonderlic.vue?vue&type=script&setup=true&lang=js"

import "./Wonderlic.vue?vue&type=style&index=0&id=ff1c2af0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1c2af0"]])

export default __exports__